/* SanaSleep cart drawer extras: reservation timer + upsell quick-add */

if (!customElements.get('sana-cart-timer')) {
  customElements.define(
    'sana-cart-timer',
    class SanaCartTimer extends HTMLElement {
      connectedCallback() {
        this.display = this.querySelector('[data-timer]');
        this.durationMs = (parseInt(this.dataset.minutes, 10) || 10) * 60 * 1000;

        let deadline = parseInt(sessionStorage.getItem('sanaCartDeadline') || '0', 10);
        const remaining = deadline - Date.now();
        if (!deadline || remaining <= 0 || remaining > this.durationMs) {
          deadline = Date.now() + this.durationMs;
          sessionStorage.setItem('sanaCartDeadline', String(deadline));
        }
        this.deadline = deadline;

        this.tick();
        this.interval = setInterval(() => this.tick(), 1000);
      }

      disconnectedCallback() {
        clearInterval(this.interval);
      }

      tick() {
        let remaining = this.deadline - Date.now();
        if (remaining <= 0) {
          this.deadline = Date.now() + this.durationMs;
          sessionStorage.setItem('sanaCartDeadline', String(this.deadline));
          remaining = this.durationMs;
        }
        const minutes = Math.floor(remaining / 60000);
        const seconds = Math.floor((remaining % 60000) / 1000);
        if (this.display) {
          this.display.textContent = `${minutes}:${String(seconds).padStart(2, '0')}`;
        }
      }
    }
  );
}

if (!customElements.get('sana-cart-upsell')) {
  customElements.define(
    'sana-cart-upsell',
    class SanaCartUpsell extends HTMLElement {
      connectedCallback() {
        this.addEventListener('click', (event) => {
          const button = event.target.closest('button[data-variant-id]');
          if (button) this.addItem(button);
        });
      }

      async addItem(button) {
        button.disabled = true;
        try {
          const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
          const response = await fetch(`${root}cart/add.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              items: [{ id: Number(button.dataset.variantId), quantity: 1 }],
            }),
          });
          if (!response.ok) throw new Error(`Add to cart failed (${response.status})`);
          await this.refreshDrawer();
        } catch (error) {
          console.error('[sana-cart-upsell]', error);
          button.disabled = false;
        }
      }

      async refreshDrawer() {
        const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        const response = await fetch(`${root}?sections=cart-drawer,cart-icon-bubble`);
        const sections = await response.json();
        const parser = new DOMParser();

        const drawerInner = document.querySelector('#CartDrawer .drawer__inner');
        if (drawerInner && sections['cart-drawer']) {
          const fresh = parser
            .parseFromString(sections['cart-drawer'], 'text/html')
            .querySelector('.drawer__inner');
          if (fresh) drawerInner.innerHTML = fresh.innerHTML;
        }

        const bubble = document.getElementById('cart-icon-bubble');
        if (bubble && sections['cart-icon-bubble']) {
          const freshBubble = parser
            .parseFromString(sections['cart-icon-bubble'], 'text/html')
            .querySelector('.shopify-section');
          if (freshBubble) bubble.innerHTML = freshBubble.innerHTML;
        }

        document.querySelector('cart-drawer')?.classList.remove('is-empty');
      }
    }
  );
}
